"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Message_1 = require("../component/Message");
var Articles_1 = require("./Articles");
var Books_1 = require("./Books");
var SignIn_1 = require("./SignIn");
var Tasks_1 = require("./Tasks");
var Videos_1 = require("./Videos");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        var _a = this.props, currentPage = _a.currentPage, signedIn = _a.signedIn;
        if (signedIn === null) {
            return false;
        }
        var Page = signedIn
            ? { articles: Articles_1.default, books: Books_1.default, tasks: Tasks_1.default, videos: Videos_1.default }[currentPage]
            : SignIn_1.default;
        return React.createElement("div", null,
            React.createElement(Page, null),
            React.createElement(Message_1.default, null));
    };
    return App;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var authentication = _a.authentication, pages = _a.pages;
    return (__assign({}, authentication, pages));
})(App);



//////////////////
// WEBPACK FOOTER
// ./src/container/App.tsx
// module id = 329
// module chunks = 0